import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import AuthContext from '../../store/AuthContext';
import AuthMdInfo from './AuthMdInfo';
import AuthMdCmd from './AuthMdCmd';
import * as services from '../../services/services';
import * as utils from '../../services/utils';

import '../Main.css';

function AuthMdMain() {
  const iuaCtx = useContext(AuthContext);

  const [validationMsg, setValidationMsg] = useState('');

  useEffect(() => {
    sessionStorage.clear();
    iuaCtx.clear();
  }, []);
  
  useEffect(() => {
    handleDisplayCmdData();
  }, [iuaCtx]);

  const history = useHistory();
  
  const iuaConnectProps = {
    handleDisplayCmdData: handleDisplayCmdData
  };

  const iuaCmdProps = {};

  function handleDisplayCmdData() {
    const cmdData = iuaConnectProps.getData(); 
    iuaCmdProps.displayCmdData(cmdData);
  }

  async function submitHandler(event) {
    event.preventDefault();
    let result = await iuaConnectProps.trigger();
    if (!result) {
      setValidationMsg('Could not submit the request due to missing or invalid input data. Review the data entered.');
      return;
    } 
    
    const cmdData = iuaConnectProps.getData();

    result = await services.getMD(cmdData.wellKnownUri); 

    iuaCtx.setAuthMd(result);

    sessionStorage.setItem('transType', utils.TRANS.auth_metadata);

    history.push("/authorize");
  }

  return (
  <div>
    <div className="container main-body">
      <form className="main-form">
      
        <AuthMdInfo connectData={iuaConnectProps}></AuthMdInfo>

        <div className="row">
          <div className="col-8">
            <AuthMdCmd cmdData={iuaCmdProps}></AuthMdCmd>
          </div>
        </div>

        <div className="row">
          <div className="col-7">
            <div className="main-form-submit validation-msg error">

              {/* VALIDATION MSG */}

              <div>{validationMsg}</div>

            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-7">
            <div className="main-form-submit spc-pb-15">

              {/* AUTHORIZATION SERVER METADATA */}

              <button onClick={submitHandler} className="btn btn-danger main-form-submit-button"> Send Request 
                {/* <i className="fa fa-paper-plane-o ml-1"></i> */}
              </button>

            </div>
          </div>
        </div>

      </form>
    </div>
  </div>  
  );
}

export default AuthMdMain;
